export interface DepartmentSectionActionTypes {
    type: DepartmentSectionActions;
    payload?: any;
  }
  
  export enum DepartmentSectionActions {
    GET_DEPARTMENT_SECTION_LIST = "GET_DEPARTMENT_SECTION_LIST",
    SET_DEPARTMENT_SECTION_LIST = "SET_DEPARTMENT_SECTION_LIST",
    SET_DEPARTMENT_IN_SECTION = "SET_DEPARTMENT_IN_SECTION",  //setting departments in sections
  }
  